/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useEffect, useState } from "react";

import Card from "@mui/material/Card";
import { Box, LinearProgress } from "@mui/material";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataPaginateTable from "examples/Tables/DataPaginateTable";

import { URL_API } from "config";

import moment from "moment";
import { CSVLink } from "react-csv";
import MDButton from "components/MDButton";
import { useDashboardCardContext } from "context/DashboardCardContext";

function TableCardAwaitingSignature() {
  const [cooperateds, setCooperateds] = useState([]);
  const [cooperatedsDataTable, setCooperatedsDataTable] = useState([]);

  const [loading, setLoading] = useState(false);
  const [tableLimit, setTableLimit] = useState(10);
  const [tablePage, setTablePage] = useState(1);
  const [tableTotal, setTableTotal] = useState(0);

  const { dateCardWaitingSignatureFrom, dateCardWaitingSignatureTo } = useDashboardCardContext();

  let tag = localStorage.getItem("Tag");

  const dataTableData = {
    columns: [
      { Header: "Criação", accessor: "created_at" },
      { Header: "Atualização", accessor: "updated_at" },
      { Header: "Nome", accessor: "full_name" },
      { Header: "CPF", accessor: "cpf" },
    ],
    rows: cooperateds,
  };

  useEffect(() => {
    (async () => {
      const response = await getCooperatedsDataTable();

      setCooperatedsDataTable(response);
    })()
  }, [])

  useEffect(() => {
    (async () => {
      setLoading(true);

      await getCooperateds(tablePage, tableLimit);

      setLoading(false);
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tablePage, tableLimit]);

  async function getCooperateds(page = 1, limit = 10) {
    const response = await axios.get(`${URL_API}/dash/waiting-signature?list=true&page=${page}&limit=${limit}&dateFrom=${dateCardWaitingSignatureFrom}&dateTo=${dateCardWaitingSignatureTo}`, {
      headers: {
        Authorization: `Bearer ${tag}`,
      },
    });

    for (const data of response.data.data) {
      data.created_at = moment(data.created_at).format('DD/MM/YYYY');
      data.updated_at = moment(data.updated_at).format('DD/MM/YYYY');
    }

    setCooperateds(response.data.data);
    setTableTotal(response?.data.meta?.total);
  };

  async function getCooperatedsDataTable() {
    const response = await axios.get(`${URL_API}/dash/waiting-signature?list=true&datatable=true&dateFrom=${dateCardWaitingSignatureFrom}&dateTo=${dateCardWaitingSignatureTo}`, {
      headers: {
        Authorization: `Bearer ${tag}`,
      },
    });

    return response.data;
  };

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox pt={2}>
              <MDBox
                p={3}
                lineHeight={1}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h5" fontWeight="medium">
                  Filtro de Aguardando Assinatura
                </MDTypography>

                {cooperateds.length > 0 && (
                  <div style={{ display: "flex" }}>
                    <CSVLink filename="CooperatedTableAwaitingSignature.csv" data={cooperatedsDataTable}>
                      <MDButton color="light">BAIXAR TABELA CSV</MDButton>
                    </CSVLink>
                    <div style={{ width: "10px" }} />
                    <CSVLink
                      filename="CooperatedTableAwaitingSignature.xls"
                      data={cooperatedsDataTable}
                      separator=";"
                      enclosingCharacter=""
                    >
                      <MDButton color="light">BAIXAR TABELA XLS</MDButton>
                    </CSVLink>
                  </div>
                )}
              </MDBox>
            </MDBox>
          </Card>
          <MDBox pt={2}>
            <Card>
              {
                loading ?
                  <Box sx={{ width: '100%' }}>
                    <LinearProgress sx={{ overflow: 'hidden' }} />
                  </Box> :
                  <DataPaginateTable
                    entriesPerPage={{ defaultValue: tableLimit }}
                    table={dataTableData}
                    setTableLimit={setTableLimit}
                    tableLimit={tableLimit}
                    setTablePage={setTablePage}
                    tablePage={tablePage}
                    tableTotal={tableTotal}
                  />
              }
            </Card>
          </MDBox>
        </MDBox>
      </DashboardLayout>
    </>
  );
}

export default TableCardAwaitingSignature;
